import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from "react";
import { ResponsivePicture, singleCrop } from "../../../Shared/components/Image";
import { VideoComponent } from "../../../Shared/components/Video/VideoComponent";
import { slugify } from "../../custom_utils/helpers";
import { Link } from "./library/link";
export const Teasers = (p)=>{
    const keyPrefix = p.keyPrefix ? p.keyPrefix : 'teaser-';
    return /*#__PURE__*/ _jsx("ul", {
        className: "teasers row",
        children: p.items.map((i, k)=>/*#__PURE__*/ _jsx(Teaser, {
                ...i,
                row_count: p.row_count
            }, keyPrefix + slugify(i.title)))
    });
};
export const Teaser = (p)=>/*#__PURE__*/ _jsx("li", {
        className: `teaser ${p.imageUrl ? 'teaser--image' : ''} ${p.extraClasses ? p.extraClasses : ''} ${p.row_count == 4 ? "col-xs-12 col-sm-6 col-md-4 col-ld-3" : "col-xs-12 col-sm-6 col-md-4"}`,
        children: TeaserInner({
            linkUrl: p.linkUrl,
            teaserContent: TeaserContent(p),
            title: p.title
        })
    });
export const TeaserInner = (p)=>/*#__PURE__*/ _jsx(Link, {
        url: p.linkUrl,
        className: "teaser__link",
        "aria-labelledby": `a11y-teaser-title-${slugify(p.title)}`,
        children: p.teaserContent
    });
export const TeaserContent = (p)=>{
    const { video, headingLevel: Heading } = p;
    return /*#__PURE__*/ _jsxs("article", {
        "data-anchor": slugify(p.title),
        className: "teaser__inner",
        children: [
            /*#__PURE__*/ _jsxs("header", {
                className: "teaser__header",
                children: [
                    /*#__PURE__*/ _jsx(Heading, {
                        className: "teaser__title title--m",
                        id: `a11y-teaser-title-${slugify(p.title)}`,
                        children: /*#__PURE__*/ _jsx("span", {
                            dangerouslySetInnerHTML: {
                                __html: p.title
                            }
                        })
                    }),
                    p.isTip && /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: "teaser__tip",
                                children: "Tip"
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                className: "sr-text",
                                children: " van de redactie"
                            })
                        ]
                    })
                ]
            }),
            p.intro && /*#__PURE__*/ _jsx("p", {
                className: "teaser__intro",
                dangerouslySetInnerHTML: {
                    __html: p.intro
                }
            }),
            p.footer && /*#__PURE__*/ _jsxs("footer", {
                className: "teaser__footer",
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: "sr-text",
                        children: "Locatie: "
                    }),
                    p.footer
                ]
            }),
            p.imageUrl && /*#__PURE__*/ _jsxs("div", {
                className: "teaser__visual",
                children: [
                    p.label && /*#__PURE__*/ _jsx("div", {
                        className: "teaser__label",
                        children: p.label
                    }),
                    /*#__PURE__*/ _jsx(ResponsivePicture, {
                        defaultImageUrl: p.imageUrlFallback,
                        cropsPerMedia: singleCrop(p.imageUrl),
                        alt: p.imageAlt,
                        className: "teaser__image"
                    })
                ]
            }),
            video && /*#__PURE__*/ _jsxs("div", {
                className: "teaser__visual",
                children: [
                    p.label && /*#__PURE__*/ _jsx("div", {
                        className: "teaser__label",
                        children: p.label
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "teaser__video",
                        children: /*#__PURE__*/ _jsx(VideoComponent, {
                            video,
                            showAcceptCookiesButton: false
                        })
                    })
                ]
            }),
            p.linkText && /*#__PURE__*/ _jsxs("div", {
                className: "teaser__fauxlink",
                children: [
                    /*#__PURE__*/ _jsx("svg", {
                        className: "teaser__fauxlink-icon",
                        width: "8px",
                        height: "14px",
                        "aria-hidden": "true",
                        children: /*#__PURE__*/ _jsx("use", {
                            xlinkHref: "#icon--chevron-right"
                        })
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        children: p.linkText
                    })
                ]
            })
        ]
    });
};
export const SliderTeaserContent = (p)=>{
    const { video, headingLevel: Title } = p;
    return /*#__PURE__*/ _jsxs("article", {
        "data-anchor": slugify(p.title),
        className: "teaser__inner",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "teaser__text",
                children: [
                    /*#__PURE__*/ _jsx("header", {
                        className: "teaser__header",
                        children: /*#__PURE__*/ _jsxs(Title, {
                            className: "teaser__title title--m",
                            children: [
                                p.isTip && /*#__PURE__*/ _jsx("span", {
                                    className: "teaser__tip",
                                    children: "TIP"
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    children: p.title
                                })
                            ]
                        })
                    }),
                    p.intro && /*#__PURE__*/ _jsx("p", {
                        className: "teaser__intro",
                        dangerouslySetInnerHTML: {
                            __html: p.intro
                        }
                    }),
                    p.footer && /*#__PURE__*/ _jsx("footer", {
                        className: "teaser__footer",
                        children: p.footer
                    })
                ]
            }),
            p.imageUrl && /*#__PURE__*/ _jsxs("div", {
                className: "teaser__visual",
                children: [
                    p.label && /*#__PURE__*/ _jsx("div", {
                        className: "teaser__label",
                        children: p.label
                    }),
                    /*#__PURE__*/ _jsx(ResponsivePicture, {
                        defaultImageUrl: p.imageUrlFallback,
                        cropsPerMedia: singleCrop(p.imageUrl),
                        alt: p.imageAlt,
                        className: "teaser__image"
                    })
                ]
            }),
            video && /*#__PURE__*/ _jsxs("div", {
                className: "teaser__visual",
                children: [
                    p.label && /*#__PURE__*/ _jsx("div", {
                        className: "teaser__label",
                        children: p.label
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "teaser__video",
                        children: /*#__PURE__*/ _jsx(VideoComponent, {
                            video,
                            showAcceptCookiesButton: false
                        })
                    })
                ]
            })
        ]
    });
};
export const SliderTeaser = (p)=>/*#__PURE__*/ _jsx("div", {
        className: "teaser teaser--image",
        children: TeaserInner({
            linkUrl: p.linkUrl,
            teaserContent: SliderTeaserContent(p),
            title: p.title
        })
    });
